const ACTIVE_STATUS = 'active'
const INACTIVE_STATUS = 'inactive'
const VALIDATING_STATUS = 'validating'
const FAILED_STATUS = 'failed'

const SEGCOOP_KIND = 'segcoop'
const SMTP_KIND = 'smtp'

const STATUSES = {
  [ACTIVE_STATUS]: 'ATIVO',
  [INACTIVE_STATUS]: 'INATIVO',
  [VALIDATING_STATUS]: 'Aguardando validação',
  [FAILED_STATUS]: 'Falhou',
}

const PLATFORM_OPTIONS = [
  {
    id: SEGCOOP_KIND,
    label: 'Segcoop',
  },
  {
    id: SMTP_KIND,
    label: 'SMTP',
  },
]

export default {
  ACTIVE_STATUS,
  INACTIVE_STATUS,
  VALIDATING_STATUS,
  FAILED_STATUS,
  SMTP_KIND,
  PLATFORM_OPTIONS,
  SEGCOOP_KIND,
  STATUSES,
}
